import React from 'react';
import './CodeBlock.css';

function CodeBlock({ language = 'jsx', code }) {
  return (
    <pre className="code-block">
      <code className={`language-${language}`}>
        {code}
      </code>
    </pre>
  );
}

export default CodeBlock;
